export default {
      id: "fileСopy-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "sprite.1793797381340.svg#fileСopy-usage",
      toString: function () {
        return this.url;
      }
    }